import Icon from '../components/Icon.vue'

Icon.register({
  ethernet: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 192c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16h-80v-128h-32v128h-64v-128h-32v128h-64v-128h-32v128h-64v-128h-32v128h-80c-8.8 0-16-7.2-16-16v-224c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v48h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ethernet.js
// module id = 1306
// module chunks = 0